import * as React from 'react';
export const IcMoonset = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M18 14H6c-.27 0-.52.11-.71.29-.19.18-.29.44-.29.71 0 .27.11.52.29.71.18.19.44.29.71.29h12c.27 0 .52-.11.71-.29.19-.18.29-.44.29-.71 0-.27-.11-.52-.29-.71A.973.973 0 0018 14zm-2 4H8c-.27 0-.52.11-.71.29-.19.18-.29.44-.29.71 0 .27.11.52.29.71.18.19.44.29.71.29h8c.27 0 .52-.11.71-.29.19-.18.29-.44.29-.71 0-.27-.11-.52-.29-.71A.973.973 0 0016 18zm4-8h-2.28c.07-.22.13-.45.18-.69.56-2.86-.7-5.63-2.95-7.15-.74-.5-1.66.21-1.49 1.08.18.93.14 1.93-.17 2.92-.56 1.79-1.96 3.2-3.69 3.83H4c-.55 0-1 .45-1 1s.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1V10z'
      fill='currentColor'
    />
  </svg>
);
